export default "__VITE_ASSET__af56ce25__"